import getSubdomain from './getSubdomain'

import { LanguagePreference } from 'models/LanguagePreference'

export const getDefaultLogoutURL = (lang:LanguagePreference) => {
  const langQueryValue = lang === 'es' ? 'es-mx' : 'en-us'
  const subdomain = getSubdomain(process.env.REACT_APP_MY_MEDICARE_ENV || '')

  const redirectUri = `https://${subdomain}medicare.gov/account/logout?lang=${langQueryValue}`
  return `https://${subdomain}medicare.gov/sso/signout?redirect_uri=${redirectUri}`
}

export const getDefaultLoginURL = (lang:LanguagePreference) => {
  const langQueryParam = lang === 'es' ? '?lang=es-mx' : ''
  const subdomain = getSubdomain(process.env.REACT_APP_MY_MEDICARE_ENV || '')

  return `https://${subdomain}medicare.gov/account/login${langQueryParam}`
}
